export default __webpack_public_path__ + "locales/zh-CN/Webhooks.json?hash=96058db692614510b4cd12440cba4f60";